import {
  ChecklistOption,
  ChecklistOptions,
} from "modules/projects/actions/checklist_options_fetch";

export type ChecklistSection = "default" | "recent" | "all";

export interface ChecklistOptionItem extends ChecklistOption {
  section: ChecklistSection;
}

const byName = (a: ChecklistOption, b: ChecklistOption) =>
  a.name.localeCompare(b.name);

export function buildChecklistOptions(
  options: ChecklistOptions,
): ChecklistOptionItem[] {
  const {checklists, default_issueset_id: defaultId} = options;
  const findChecklist = (id: number | null) =>
    checklists.find(checklist => checklist.id === id);

  const defaultChecklist = findChecklist(defaultId);
  const recent = options.recent_issueset_ids
    .filter(id => id !== defaultId)
    .map(findChecklist)
    .filter((checklist): checklist is ChecklistOption => Boolean(checklist));
  const pinned = defaultChecklist ? [defaultChecklist, ...recent] : recent;
  const pinnedIds = pinned.map(checklist => checklist.id);
  const rest = checklists
    .filter(checklist => !pinnedIds.includes(checklist.id))
    .sort(byName);

  return [
    ...(defaultChecklist
      ? [{...defaultChecklist, section: "default" as const}]
      : []),
    ...recent.map(checklist => ({...checklist, section: "recent" as const})),
    ...rest.map(checklist => ({...checklist, section: "all" as const})),
  ];
}

export function filterChecklistOptions(
  items: ChecklistOptionItem[],
  inputValue: string,
): ChecklistOptionItem[] {
  const query = inputValue.trim().toLowerCase();
  if (!query) {
    return items;
  }
  return items
    .filter(item => item.name.toLowerCase().includes(query))
    .sort(byName)
    .map(item => ({...item, section: "all" as const}));
}
